// Import the functions you need from the SDKs you need
// import * as dotenv from "dotenv"
import { initializeApp } from "firebase/app"
 
// dotenv.config()
// import { getAnalytics } from "firebase/analytics"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const FirebaseConfig = {
  apiKey: "AIzaSyBn3v2TwrciXFWhokgL2NBu5I9fmmw_Vr8",
  authDomain: "fire-labs-pre-alpha.firebaseapp.com",
  databaseURL: "https://fire-labs-pre-alpha-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "fire-labs-pre-alpha",
  storageBucket: "fire-labs-pre-alpha.appspot.com",
  messagingSenderId: "1024135748719",
  appId: "1:1024135748719:web:2a554995ba61d99282819a",
  measurementId: "G-4BYDJJV3P3"
};

// Initialize Firebase
export const App = initializeApp(FirebaseConfig)
// const analytics = getAnalytics(app)